import { endPoint, endpointVoucherAI } from './base.config';

export const voucher = {
  get: endPoint + 'vouchers',
  add: endPoint + 'vouchers/addByWeb',
  addPayment: endPoint + 'vouchers/addPayment',
  removePayment: endPoint + 'vouchers/removePayment', // balance
  update: endPoint + 'vouchers/:id',
  delete: endPoint + 'vouchers/:id',
  getStatistic: endPoint + 'vouchers/getStatisticByYear',
  getYears: endPoint + 'vouchers/getYears',
  getByMonth: endPoint + 'vouchers/getByMonth',
  updatePayment: endPoint + 'vouchers/payment/',
  updateMissing: endPoint + 'vouchers/missing/',
  fetchAll: `${endPoint}vouchers/fetchAll`,
  crawlVoucherEmail: `${endPoint}vouchers/crawlVoucherEmail`,
  getVoucherBalance: `${endPoint}vouchers/getVoucherBalance`,
  getMissingSummary: `${endPoint}vouchers/getMissingSummary`,
  getForwardedVoucher: `${endPoint}vouchers/getForwardedVoucher`,
  fetchAdminVoucher: `${endPoint}vouchers/fetchAdminVoucher`,
  updatePaymentStatus: endPoint + 'vouchers/updatePaymentStatus',
  getVoucherSuggestInfo: `${endPoint}vouchers/get-voucher-suggest-info`,
  deleteVoucherBySelectRowKeys: `${endPoint}vouchers/delete-list`,
};

export const voucherAi = {
  addSuggestion: `${endpointVoucherAI}/voucher-ai/get-suggestion`,
};

export const voucherV2 = {
  getVoucherBalances: `${endPoint}v2/vouchers/:id/voucher-balances`,
  addVoucherBalances: `${endPoint}v2/vouchers/:id/add-balance`,
  removeVoucherBalances: `${endPoint}v2/vouchers/:id/remove-balance/:voucherBalanceId`,
  fetchAll: `${endPoint}v2/vouchers`,
  getDetails: `${endPoint}v2/vouchers/:id/details`,
  getVoucherExtract: `${endPoint}v2/vouchers/:id/extract`,
  listVouchersSameSupplier: `${endPoint}v2/vouchers/:id/same-supplier`,
  addVoucherAllocation: `${endPoint}v2/vouchers/:id/voucher-allocation`,
  removeVoucherAllocation: `${endPoint}v2/vouchers/:id/voucher-allocation/:allocationId`,
};
